import React from 'react';
import './index.css';

export const Label14 = ({ bold=false, disabled=false, children }) => {
    const textStyle =  { fontWeight: (bold) ? '600': 'normal' };
    const cssClass = disabled ? "label14 labelDisabled" : "label14";
    return <label className={cssClass} style={textStyle}>{children}</label>;
};